import httpClient from '@/services/http.js'

import xray from '@/services/xray-service.js'

class ProjectService {
  constructor() {
    const goLive = true
    this.baseURL = process.env.VUE_APP_BACKEND_URL

    if(process.env.NODE_ENV == 'development' && goLive) {
      this.baseURL = 'https://simply-studio.appspot.com'
    }
  }

  async getAllProjects() {
    return httpClient.get(this.baseURL + '/projects', 
    ).then(r => r.data == null ? [] : r.data)
  }

  async getProject(projectName) {
    return httpClient.post(this.baseURL + '/project',
      {
        name: projectName
      },
    ).then(res => res.data)
  }
  
  async createProject (name) {
    return httpClient.post(this.baseURL + '/create',
    {
      name: name
    }
    ).then(res => {
      xray.logEvent({
        eventData: {
          action: 'project:create'
        }
      })
      return res.data
    })
  }
  
  async getFavourites (owner, projectname) {
    return httpClient.post(this.baseURL + '/favourites', 
    {
      owner: owner,
      projectname: projectname
    }
    ).then(res => res.data)
  }
  
  async markFavourites (owner, projectname, favourites) {
    return httpClient.post(this.baseURL + '/update-favourites', 
    {
      owner: owner,
      projectname: projectname,
      favourites: favourites
    }
    ).then(res => res.data)
  }

  async saveSuggestion(projectName, suggestion) {
    return httpClient.post(this.baseURL + '/save-suggestion',
    {
      projectName: projectName,
      suggestion: suggestion
    }).then(res => {
      xray.logEvent({
        eventData: {
          action: "suggestion:save",
          projectID: projectName,
        }
      })
      return res.data
    })
  }

  async loadSuggestions(projectName) {
    return httpClient.post(this.baseURL + '/get-suggestions', 
    {
      projectName: projectName
    }).then(res => res.data)
  }

  async deleteSuggestion(projectName, deleteID) {
    return httpClient.post(this.baseURL + '/delete-suggestion', 
    {
      projectName: projectName,
      deleteID: deleteID
    }).then(res => {
      xray.logEvent({
        eventData: {
          action: "suggestion:delete",
          projectID: projectName,
        }
      })
      return res.data
    })
  }

  async getSecret(project) {
    return httpClient.post(this.baseURL + '/get-secret', 
    {
      projectName: project
    }).then(res => res.data)
  }

  async validateSecret(user, projectName, secret) {
    return httpClient.post(this.baseURL + '/validate-secret', 
    {
      user: user,
      projectName: projectName,
      secret: secret
    }).then(res => res.data)
  }

  async roomUpload(formData, config) {
    return httpClient.post(this.baseURL + '/room-upload',
      formData,
      config
    )
  }

  async updateContact(projectName, contact) {
    return httpClient.post(this.baseURL + '/update-contact',
    {
      projectName: projectName,
      contact: contact
    }
    ).then(res => {
      // xray.logEvent({
      //   eventData: {
      //     action: "contact:update",
      //     projectID: projectName,
      //   }
      // })
      return res.data
    })
  }

  async deleteProject(projectName) {
    return httpClient.post(this.baseURL + '/delete',
    {
      name: projectName
    }).then(res => res.data)
  }
  
  // eslint-disable-next-line no-unused-vars
  async updateProject(id, updates) {
    throw("who that?")
  }
}

export default new ProjectService()